
type DoneFn = () => void;

export class TimedEvent {

	constructor(time:number, fn:DoneFn){
		this._fn = fn;
		this._time = time;
	}

	public run(){
		this._tick = setTimeout(() => {
			if(this._fn){
				this._fn();
			}
		}, this._time);
	}

	public cancel(){
		if(this._tick){ clearTimeout(this._tick); }
		this._tick = undefined;
	}

	private _tick?:NodeJS.Timeout;
	private _time:number = 0;
	private _fn?:DoneFn;
}